import { graphql } from "gatsby";
import React from "react";
import { Container } from "react-bootstrap";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../ParagraphLargeSliderContentBlock/ParagraphLargeSliderContentBlock.scss";
import Slider from "react-slick";
import ExtractRichText from "../../molecules/ExtractRichText";
import {
  HandleNextArrow,
  HandlePrevArrow,
} from "../../molecules/SliderButtons";
import "./paraFlagshipSlider.scss";

export const ParagraphFlagshipSlider = ({ node }) => {
  console.log("node", node);
  const image = getImage(
    node?.relationships?.field_ls_slider_image?.relationships?.field_media_image
  );

  var settings = {
    infinite: false, // Infinitely wrap around contents
    speed: 500, // Animation speed in milliseconds
    slidesToShow: 1, // How many slides to show in one frame
    slidesToScroll: 1, // How many slides to scroll at once
    arrows: true,
    prevArrow: <HandlePrevArrow />, // Customize Left arrow
    nextArrow: <HandleNextArrow extraClasses="flagship-arrow" />, // Customize Right arrow
    touchMove: false, // If need swipe slider with fingers By Default it's True
    responsive: [
      // Customize based on breakpoints
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          touchMove: true,
        },
      },
    ],
  };

  console.log(node);
  return (
    <Container className="general-container mb-5 p-0 flagship-slider">
      {node?.field_component_title && (
        <h2 className="ls">{node?.field_component_title}</h2>
      )}
      <Slider {...settings} className="carousel-slide">
        {node?.relationships?.field_carousel_item?.map((item, key) => (
          <>
            <div className="ls-slide-wrapper">
              <div className="ls-slide-wrapper-image">
                <GatsbyImage
                  className="w-100 h-100 object-fit-cover"
                  image={getImage(
                    item?.relationships?.field_ls_slider_image?.relationships
                      ?.field_media_image
                  )}
                  alt={item?.field_ls_component_title}
                ></GatsbyImage>
              </div>
              <div
                className={`ls-slide-wrapper-body bg-clr-${item?.field_ls_background_color}`}
              >
                <div className="w-100">
                  {item?.relationships?.field_ls_product_tag && (
                    <p className="ls-eyebrow">
                      {item?.relationships?.field_ls_product_tag?.name}
                    </p>
                  )}

                  <h3 className="ls-title"> {item?.field_ls_title}</h3>
                  <ExtractRichText richText={item?.field_ls_body?.value} />

                  <div className="cta-wrapper">
                    {item?.relationships?.field_ls_cta_links?.map(
                      (cta, key) => {
                        return (
                          <>
                            {cta?.field_link?.title && (
                              <div key={key} className="me-1">
                                <a
                                  href={cta?.field_link?.url}
                                  target={
                                    cta?.field_link?.options?.attributes?.target
                                  }
                                  rel={
                                    cta?.field_link?.options?.attributes?.rel
                                  }
                                  aria-label={
                                    cta?.field_link?.options?.attributes
                                      ?.aria_label
                                  }
                                  className={`btn btn-${cta?.field_cta_colour} ${cta?.field_link?.options?.attributes?.class}`}
                                >
                                  {cta?.field_link?.title}
                                </a>
                              </div>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        ))}
      </Slider>
    </Container>
  );
};

export const fragment = graphql`
  fragment ParagraphFlagshipSlider on paragraph__flagship_slider {
    field_component_title
    relationships {
      field_carousel_item {
        field_ls_title
        field_ls_component_title
        field_ls_body {
          value
        }
        field_ls_background_color
        relationships {
          field_ls_product_tag {
            name
          }
          field_ls_slider_image {
            relationships {
              field_media_image {
                gatsbyImage(width: 1700, quality: 100, placeholder: BLURRED)
              }
            }
          }
          field_ls_cta_links {
            field_cta_colour
            field_icon_type
            field_link {
              title
              url
              options {
                attributes {
                  aria_label
                  class
                  rel
                  target
                }
              }
            }
          }
        }
      }
    }
  }
`;
